import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';

import VueRouter from 'vue-router'
import store from './store'

// router setup
import routes from './routes/routes'

import localeFilter from './filters/localize.filter'

import GlobalComponents from './globalComponents'

Vue.config.productionTip = false

// plugin setup
Vue.use(VueRouter)

Vue.use(GlobalComponents);

// filters setup
Vue.filter('localize', localeFilter)

// configure router
const router = new VueRouter({
  routes,
  linkActiveClass: 'routeactive',
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || to.meta.label || to.name;

  let admPath = to.path.toString().includes('/admin/')
  let isAdmin = store.state.authentication.grants.some(el =>  el.grantType == 'admin');
  
  if (admPath && !isAdmin) {
    router.push('access')
    next()
  }
  next()
})

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
